import {$get, $post, $postForm} from "./Ajax";
import {$, $$, empty, getParentElementByClassName} from "./Dom";
import {fadeIn, fadeOut, fadeOutFadeIn} from "./Animate";
import {afficherDate, toggleMessageBody} from "./MessagerieMessage";
import {createErrorNotification} from "../../portail/js/Notifications";
import {initMessagerieEnvoi} from "./MessagerieEnvoiMessage.ts";
import {initTooltips} from "./Tooltip.ts";

let loading = false
// @ts-ignore
let last_messages_size = 0
let archive = false
let nonlu = !window.Openscop.afficher_message_lu_par_defaut
let mesdossier = false
let nonassigne = false
let manif: string = ""
let trac_only = false
let filtre_custom = ""
let filtre_show = 0
const list_inputs = ["suivi", "action", "forum", "conv", "convoc", "trac", "nouv", "dossier", "docjoin", "avis", "preavis", "arrete", "recepisse", "envoi", "recu", "reponseofficielle"]

export function getMessagerieList(manif?: string | undefined) {
    const url = new URL(location.href)
    if (window.Openscop.afficher_message_lu_par_defaut) {
        url.searchParams.set('nonlu', "1")
    }
    if (url.searchParams.has('mesdossier')) {
        mesdossier = true
    }
    if (manif) url.searchParams.append('manif', manif)
    $get(window.Openscop.url_messagerie, url.searchParams).then((data) => {
        const webmail = $<HTMLElement>('#messagerie')
        if (webmail) {
            webmail.innerHTML = data.body
            manif = $<HTMLElement>('[data-manif]')?.dataset?.manif ?? ""
            afficher_filtre_perso().then(initFiltres)
            initFiltreValue()
            releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom)
            initTooltips(webmail)
        }
    })
}

/*
fonction pour afficher la liste des filtres personnalisé
 */
function afficher_filtre_perso() {
    return $get(window.Openscop.url_messagerie_filtre_perso).then((data) => {
        const filtres = JSON.parse(data.body);
        let display = `<div class="barre_list_filtre fr-m-2w">`;
        display += `<div class="list_filtre"><button>Mes filtres :</button></div>`
        for (const filtre of filtres) {
            display += `<div class="list_filtre">
                <button class="fr-tag filtre_perso_list" data-options="${filtre.fields.option}">${filtre.fields.titre}</button>
                <button class="fr-btn fr-btn--secondary filtre_perso_list_remove d-none" id="supp_${filtre.pk}">Confirmer la suppression du filtre "${filtre.fields.titre}"</button>
                <button class="fr-btn fr-btn--secondary filtre_perso_list_confirm d-none" id="supp_conf_${filtre.pk}">Supprimer le filtre "${filtre.fields.titre}" ?</button> </div>`

        }
        display += `</div><div class="list_filtre">
                    <button class="btn_supp" title="Supprimer un filtre" aria-label="Supprimer un filtre"><i class="remix-supprimer" aria-hidden="true"></i></button>
                    <button class="anul_supp d-none" aria-label="Annuler la suppression du filtre" title="Annuler la suppression du filtre"><i class="remix-annuler" aria-hidden="true"></i></button>
                </div>`;
        const filtres_perso = $<HTMLElement>('#filtre_perso')
        if (filtres_perso) {
            filtres_perso.innerHTML = display;
            if (filtres.length === 0) {
                fadeOut(filtres_perso);
            } else {
                fadeIn(filtres_perso);
            }
        }
    }).then(() => {
        $$('.filtre_perso_list').forEach(element => element.addEventListener('click', SelectionFiltrePersonaliser))
        $$('.btn_supp').forEach(element => element.addEventListener('click', showDeleteFiltresPerso))
        $$('.anul_supp').forEach(element => element.addEventListener('click', hideDeleteFiltresPerso))
        $$('.filtre_perso_list_confirm').forEach(element => element.addEventListener('click', showConfirmDeleteFiltrePerso))
        $$('.filtre_perso_list_remove').forEach(element => element.addEventListener('click', handleFiltrePersoDelete))
    })
}

function initFiltres() {
    $<HTMLElement>('#filtre_save')?.addEventListener('click', handleShowSaveFiltre)
    $<HTMLElement>('#tout_lire')?.addEventListener('click', mettreALuTousLesMessages)
    $$('#filtre_mail').forEach(element => element.addEventListener('click', handleFiltreMailClick))
    $$('#filtre_save').forEach(element => element.addEventListener('click', afficherFormulaireEnregistrementFiltrePerso))
    $$('#trac_only').forEach(element => element.addEventListener('click', handleTracabilite))
    $$('#form_filtre_submit').forEach(element => element.addEventListener('click', saveCurrentFiltresToFiltrePerso))
    $$('#show_write').forEach(element => element.addEventListener('click', handleBasculementLectureEcriture))
    $$('.filter_bar').forEach(element => element.addEventListener('click', filtreSelection))
    $$('#filtre_reset').forEach(element => element.addEventListener('click', afficherTousLesMessages))
    $$('#showMore').forEach(element => element.addEventListener('click', showMoreMessages))
    $$('#show_mail').forEach(element => element.addEventListener('click', handleBasculementLectureEcriture))
    $$('#refresh').forEach(element => element.addEventListener('click', handleRefreshMessage))
    $$('#archive').forEach(element => element.addEventListener('click', toggleArchive))
    $$('#li_non_lu').forEach(element => element.addEventListener('click', toggleNonLu))
    $$('#mes_dossier').forEach(element => element.addEventListener('click', toggleMesDossier))
    $$('#non_assigne').forEach(element => element.addEventListener('click', toggleNonAssigne))
}

function initFiltreValue() {
    let url_str = window.location.href;
    let url = new URL(url_str);
    let go_to = url.searchParams.get('cpt');
    let option = '';
    if (go_to) {
        if (go_to === 'conversation') {
            option += '&conv=1'
        }
        if (go_to === 'convocation') {
            option += '&convoc=1'
        }
        if (go_to === "forum") {
            option += '&forum=1'
        }
        if (go_to === "action") {
            option += '&action=1'
        }
        if (go_to === "suivi") {
            option += "&suivi=1"
        }
        if (go_to === "nouveaute") {
            option += "&nouv=1"
        }
        if (go_to === "reponseofficielle") {
            option += "&reponseofficielle=1"
        }
        filtre_custom = option + "&dossier=1&docjoin=1&avis=1&preavis=1&arrete=1&recepisse=1&envoi=1&recu=1";
        let tab = filtre_custom.split('&');
        $$<HTMLInputElement>('.filter_bar').forEach(filtre => filtre.checked = false);
        for (const value of tab) {
            const content = value.split("=")
            if (content[1] === "1") {
                const filtre = $<HTMLInputElement>(`#filter_${content[0]}`)
                if (filtre) filtre.checked = true
            }
        }
    }
}

function showMoreMessages() {
    window.Openscop.messagerieLimit += 20;
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, false, false);
}

function triHeureMessages(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByClassName(event.target, 'sort-heure')
    if (target) {

        if (event.type === "click" || (event.type === "keyup" && (event.code === "Enter" || event.code === "NumpadEnter"))) {
            const ordre = target.getAttribute('data-ordre');
            filtre_custom = get_filtre_now() + "&ordre_antechronologique=" + ordre
            releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true, true)
        }
    }
}

function get_filtre_now() {
    let option = '';
    for (const type of list_inputs) {
        const input = $<HTMLInputElement>(`#filter_${type}`)
        if (input) {
            if (input.checked) option += `&${type}=1`
        }
    }
    return option
}

function releve_du_courrier(limite: number, filtre: string, reset: boolean = false, animate: boolean = true) {
    loading = true
    const messageList = $<HTMLElement>('#messages')
    if (messageList) {
        const showMoreBtn = $<HTMLButtonElement>('#showMore')
        fadeIn(showMoreBtn)
        manif = $<HTMLElement>('[data-manif]')?.dataset?.manif ?? ""
        if (animate) fadeOut(messageList, '100ms').then(() => {
            if (!loading) fadeIn(messageList)
        })
        if (reset) last_messages_size = 0
        let baseUrl = window.Openscop.url_messagerie_prendre_msg
        if (archive) baseUrl = window.Openscop.url_messagerie_prendre_msg_archive
        let url = baseUrl + "?limit=" + limite + "&manif=" + manif;
        if (trac_only) {
            url += "&trac_only=1"
        } else {
            url += get_filtre_now()
            if (filtre !== "") {
                url = window.Openscop.url_messagerie_prendre_msg + "?limit=" + limite + "&manif=" + manif + filtre
            }
        }
        url += nonlu ? '&nonlu=1' : ''
        url += mesdossier ? '&mesdossier=1' : ''
        url += nonassigne ? '&nonassigne=1' : ''
        if (showMoreBtn) fadeIn($('i', showMoreBtn))
        $get(url).then((data) => {
            const responseSize = Number(data.response.headers.get('Content-Length'))
            if (showMoreBtn) fadeOut($('i', showMoreBtn))
            messageList.innerHTML = (data.body)
            afficherDate()
            last_messages_size = responseSize
            initMessageListeners(archive)
            fadeIn(showMoreBtn)
        }).finally(() => {
            fadeIn(messageList)
            initTooltips(messageList)
            loading = false
            const sortHeureElement = $<HTMLElement>('.sort-heure')
            sortHeureElement?.addEventListener('click', triHeureMessages)
            sortHeureElement?.addEventListener('keyup', triHeureMessages)
        })
    }
}


function initMessageListeners(archive: boolean) {
    $$<HTMLElement>('.title_msg').forEach(element => {
        element.addEventListener('click', () => {
            toggleMessageBody(element, archive)
        })
        element.addEventListener('keyup', (event) => {
            if ((event.type === "keyup" && (event.code === "Enter" || event.code === "NumpadEnter"))) {
                element.click()
            }
        })
    })
}

function SelectionFiltrePersonaliser(event: DOMEvent<HTMLInputElement>) {
    const target = event.target
    filtre_custom = target.dataset.options
    $$<HTMLElement>('.filtre_perso_list').forEach(element => element.style.fontWeight = 'normal')
    target.style.fontWeight = 'bold'
    trac_only = false
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true);
    let tab = filtre_custom.split('&');
    $$<HTMLInputElement>('.filter_bar').forEach(filtre => filtre.checked = false)
    for (const value of tab) {
        const content = value.split("=")
        if (content[1] === "1") {
            const filtre = $<HTMLInputElement>(`#filter_${content[0]}`)
            if (content[0] === 'nonlu') {
                nonlu = !!content[1]
            } else {
                if (filtre) filtre.checked = true
            }
        }
    }
    last_messages_size = 0
}

function showDeleteFiltresPerso() {
    const target = $<HTMLButtonElement>('.btn_supp')
    const annulSuppression = $<HTMLElement>('.anul_supp')
    const confirmDelete = $$<HTMLElement>('.filtre_perso_list_confirm')
    const listFiltres = $$<HTMLElement>('.filtre_perso_list')
    if (listFiltres && confirmDelete && annulSuppression && target) {
        fadeOutFadeIn(target, annulSuppression)
        for (let i = 0; i < confirmDelete.length; i++) {
            fadeOutFadeIn(listFiltres[i], confirmDelete[i])
        }
    }
}

function hideDeleteFiltresPerso() {
    const target = $<HTMLElement>('.anul_supp')
    const buttonSuppression = $<HTMLElement>('.btn_supp')
    const confirmDelete = $$<HTMLElement>('.filtre_perso_list_confirm')
    const deleteButton = $$<HTMLElement>('.filtre_perso_list_remove')
    const listFiltres = $$<HTMLElement>('.filtre_perso_list')
    if (listFiltres && confirmDelete && buttonSuppression && deleteButton && target) {
        fadeOutFadeIn(target, buttonSuppression)
        for (let i = 0; i < confirmDelete.length; i++) {
            if (deleteButton[i].classList.contains('d-none')) {
                fadeOutFadeIn(confirmDelete[i], listFiltres[i])
            } else {
                fadeOutFadeIn(deleteButton[i], listFiltres[i])
            }
        }
    }
}

function showConfirmDeleteFiltrePerso(event: DOMEvent<HTMLElement>) {
    const target = event.target
    let id = target.id.split('_')[2];
    const supBtn = $<HTMLElement>('#supp_' + id)
    if (supBtn && target) {
        fadeOutFadeIn(target, supBtn)
    }
}

function handleFiltrePersoDelete(event: DOMEvent<HTMLElement>) {
    const target = event.target
    let id = target.id.split('_')[1];
    $get(window.Openscop.url_messagerie_filtre_perso_del, {pk: id}).then((data) => {
        if (data.response.status === 200) {
            afficher_filtre_perso();
        }
    })
}

function toggleArchive() {
    archive = !archive
    let activeElement: HTMLElement | undefined = undefined
    let inactiveElement: HTMLElement | undefined = undefined
    $$<HTMLElement>('.icon-archive').forEach(element => {
        if (element.classList.contains('d-none')) inactiveElement = element
        else activeElement = element
    })
    if (activeElement && inactiveElement) {
        fadeOutFadeIn(activeElement, inactiveElement)
    }
    window.Openscop.messagerieLimit = 20;
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true, true)
}

function toggleNonLu() {
    nonlu = !nonlu
    let activeElement: HTMLElement | undefined = undefined
    let inactiveElement: HTMLElement | undefined = undefined
    $$<HTMLElement>('.icon-nonlu').forEach(element => {
        if (element.classList.contains('d-none')) inactiveElement = element
        else activeElement = element
    })
    if (activeElement && inactiveElement) {
        fadeOutFadeIn(activeElement, inactiveElement)
    }
    window.Openscop.messagerieLimit = 20;
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true, true)
}


function toggleMesDossier() {
    mesdossier = !mesdossier
    let activeElement: HTMLElement | undefined = undefined
    let inactiveElement: HTMLElement | undefined = undefined
    $$<HTMLElement>('.icon-dossier').forEach(element => {
        if (element.classList.contains('d-none')) inactiveElement = element
        else activeElement = element
    })
    if (activeElement && inactiveElement) {
        fadeOutFadeIn(activeElement, inactiveElement)
    }
    window.Openscop.messagerieLimit = 20;
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true, true)
}


function toggleNonAssigne() {
    nonassigne = !nonassigne
    let activeElement: HTMLElement | undefined = undefined
    let inactiveElement: HTMLElement | undefined = undefined
    $$<HTMLElement>('.icon-non-assigne').forEach(element => {
        if (element.classList.contains('d-none')) inactiveElement = element
        else activeElement = element
    })
    if (activeElement && inactiveElement) {
        fadeOutFadeIn(activeElement, inactiveElement)
    }
    window.Openscop.messagerieLimit = 20;
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true, true)
}

function handleShowSaveFiltre(event: DOMEvent<HTMLElement>) {
    const input = $<HTMLElement>('#form_filtre')
    if (input) fadeOutFadeIn(event.target, input)
}

function mettreALuTousLesMessages() {
    let option = get_filtre_now()
    const url = "/messagerie/lu/?type=all&manif=" + manif + option
    $post(url).then(() => {
        releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true)
    })
}

function affichage_envoi() {
    $get(window.Openscop.url_messagerie_envoi_unique, {manif: manif}).then((data) => {
        const container = $('#show_writediv')
        if (container) {
            container.innerHTML = data.body
            initMessagerieEnvoi(container)
        }
    })
}

function handleFiltreMailClick(event: DOMEvent<HTMLElement>) {
    event.preventDefault();
    if (filtre_show === 0) {
        fadeIn($('#collapsefiltre'));
        filtre_show = 1;
    } else {
        fadeOut($('#collapsefiltre'));
        filtre_show = 0;
    }
}

function afficherFormulaireEnregistrementFiltrePerso(event: DOMEvent<HTMLElement>) {
    const formFiltre = $<HTMLElement>('#form_filtre')
    if (formFiltre) fadeOutFadeIn(event.target, formFiltre)
}

function handleTracabilite() {
    trac_only = true
    $$<HTMLElement>('.filtre_perso_list').forEach(element => element.style.fontWeight = 'normal')
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true)
}

function saveCurrentFiltresToFiltrePerso() {
    let options = get_filtre_now()
    const titreElement = $<HTMLInputElement>('#nom_filtre')
    if (titreElement) {
        const titre = titreElement.value
        const formData = new FormData()
        formData.append('titre', titre)
        formData.append('option', options)
        $postForm(window.Openscop.url_messagerie_filtre_perso, formData).then((data) => {
            if (data.body === "200") {
                afficher_filtre_perso()
                const saveFiltre = $<HTMLElement>('#filtre_save')
                const formFiltre = $<HTMLElement>('#form_filtre')
                if (saveFiltre && formFiltre) fadeOutFadeIn(formFiltre, saveFiltre)
            } else {
                createErrorNotification({message: data.body})
            }
        })
    }
}

function handleBasculementLectureEcriture(event: DOMEvent<HTMLElement>) {
    const target = getParentElementByClassName(event.target, 'navmail')
    if (target) {
        let id = `#${target.id}div`
        event.preventDefault();
        if (id === '#show_writediv') {
            fadeOutFadeIn($('#show_maildiv'), $(id))
            fadeOut($('#refresh'))
            fadeIn($('#show_mail'))
            fadeOut($('#li_non_lu'))
            fadeOut($('#filtre_perso'))
            fadeOut($('#show_write'))
            fadeOut($('#archive'))
            fadeOut($('#trac_only'))
            fadeOut($('#filter_bar'))
            fadeOut($('#filtre_mail'))
            fadeOut($('#collapsefiltre'))
            fadeOut($('#filtre_reset'))
            affichage_envoi();
            filtre_show = 0
        }
        if (id === '#show_maildiv') {
            fadeOutFadeIn($('#show_writediv'), $(id))
            fadeIn($('#refresh'))
            fadeOut($('#show_mail'))
            fadeIn($('#show_write'))
            fadeIn($('#archive'))
            fadeIn($('#trac_only'))
            fadeIn($('#filtre_perso'))
            fadeIn($('#li_non_lu'))
            fadeIn($('#filter_bar'))
            fadeIn($('#filtre_mail'))
            fadeIn($('#filtre_reset'))
            empty($('#show_writediv'))
            empty($('#information'))
            trac_only = false
            releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true, true);
        }
        toggleShowMailContent()
    }
}

function filtreSelection() {
    filtre_custom = "";
    $$<HTMLElement>('.filtre_perso_list').forEach(element => element.style.fontWeight = 'normal')
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true)
}

function afficherTousLesMessages() {
    filtre_custom = "";
    $$<HTMLInputElement>('.filter_bar').forEach(element => element.checked = true)
    $$<HTMLElement>('.filtre_perso_list').forEach(element => element.style.fontWeight = 'normal')
    trac_only = false
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom, true);
}

function toggleShowMailContent() {
    let activeElement: HTMLElement | undefined = undefined
    let inactiveElement: HTMLElement | undefined = undefined
    $$<HTMLElement>('.icon-show-mail').forEach(element => {
        if (element.classList.contains('d-none')) inactiveElement = element
        else activeElement = element
    })
    if (activeElement && inactiveElement) {
        fadeOutFadeIn(activeElement, inactiveElement)
    }
}

function handleRefreshMessage() {
    releve_du_courrier(window.Openscop.messagerieLimit, filtre_custom)
}